import { accountTypes } from '../custom/utils/accountTypes';

export const getIsMentor = currentUser => {
  if (!currentUser) return null;

  return currentUser.attributes.profile.protectedData.accountType === accountTypes.mentor;
};

export const getIsStudent = currentUser => {
  if (!currentUser) return null;

  return currentUser.attributes.profile.protectedData.accountType === accountTypes.student;
};

export const getHasProfileListing = currentUser => {
  if (!currentUser) return null;

  return currentUser.attributes.profile.privateData?.profileListingId ? true : false;
};

export const getProfileListingId = currentUser => {
  if (!currentUser) return null;

  return currentUser.attributes.profile.privateData?.profileListingId;
};

export const getCreditsAmont = currentUser => {
  if (!currentUser) return null;

  return currentUser.attributes.profile.protectedData?.totalCredits || 0;
};
